import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardModal from "./CardModal";
import wallpaper from "../img/wallpaper4.webp";
import projects from "../data/projects";

export default () => {
  //settings for card-carousel
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [selection, setSelection] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setLoading(false);
    setShow(false);
  };
  const handleShow = () => {
    setLoading(true);
    setShow(true);
  };

  //  function to find the project index of the selection, then save to selection state and use in Modal.
  function handleSelection(e) {
    let index = projects.findIndex((x) => x.name === e.target.value);
    handleShow();
    setSelection(projects[index]);
  }
  return (
    <Styles>
      <h1 className="headingtext">
        <b>The Projects</b>
      </h1>
      <Slider {...settings}>
        {projects.map((x) => (
          <CardData
            key={x.id}
            name={x.name}
            image={x.image}
            tag={x.tag}
            onClick={handleSelection}
          />
        ))}
      </Slider>
      <CardModal
        show={show}
        onLoad={loading}
        handleClose={handleClose}
        {...selection}
      />
    </Styles>
  );
};

function CardData(props) {
  return (
    <Card className="card-slide border-muted">
      <Card.Img variant="top" src={props.image} />
      <Card.Body>
        <Card.Title>{props.name}</Card.Title>
        {props.tag.map((x) => (
          <span key={x}>
            <Badge variant="info">{x}</Badge>
            {"   "}
          </span>
        ))}
        <Button
          variant="outline-secondary"
          className="btn-block stretched-link"
          value={props.name}
          onClick={props.onClick}
        >
          Read More
        </Button>
      </Card.Body>
    </Card>
  );
}

const Styles = styled.div`
background-image: url(${wallpaper});
background-attachment: fixed;
background-position: center;
background-repeat: no-repeat;
background-size: cover;
padding: 3% 2% 0% 2%;
min-height: 100vh;


.headingtext{
    color:white;
    text-align:center;
    margin-bottom:30px;
}
.card-slide{
    padding:30px 80px 30px 80px;
}
.card-slide:hover { 
    transform: scale(1.1); 
}
.slick-list{
    width:90%;
    text-align:center;
    margin: 0 0 0 4.5%;
}
.slick-next{
    right:0.5%;
}
.slick-prev{
    left:0.5%;
}
.card-img-top{
    max-width: 100%;
    padding:10px 20px 20px 10px;
    height: 25vh;
    object-fit: cover;
}
.btn-block{
    margin-top:4%;
}

@media (min-width: 2200px) {
    padding: 3% 10% 0% 10%;
}

@media (max-width: 1536px) {
    .card-slide{
        padding:30px 30px 30px 30px;
    }
    .card-img-top{
        height: 35vh;
}

@media (max-width: 1024px) {
    min-height: 60vh;

    .card-img-top{
    height: 15vh;
    }
    .card-slide{
        min-height:450px;
    }
}
@media (max-width: 768px) {
    .card-slide{
        min-height:400px;
    }

@media (max-width: 736px) {
    padding: 64px 0px 0px 0px;
    min-height: 100vh;

    .card-img-top{
    height: 20vh;
    padding:0px 0px 0px 0px;
    }
    .card-slide{
        min-height:325px;
    }
    .slick-slide {
        margin-right:0px;
    }
}
`;
